/* eslint-disable react/forbid-prop-types */
import React from 'react';
import * as XLSX from 'xlsx';
import { Row, Col, Button } from 'reactstrap';
import PropTypes from 'prop-types';
import { setCurrencyFormat } from '../../../../utils/helpers';
import ResizableDataTable from '../../../Tables/ResizableTable/components/ResizableReactTable';


const customerTable = ({ data, tableHeaderData }) => {
    const excelData = data?.length && data.map((item) => {
        const updated = { ...item };
        const { customerId, openBalance } = updated
        updated.customerId = setCurrencyFormat(Number(customerId).toFixed(0), false);
        updated.openBalance = setCurrencyFormat(Number(openBalance).toFixed(2), true);
        return updated

    });

    const handleDownload = () => {
        if (!data.length) return;

        // Create a new workbook
        const wb = XLSX.utils.book_new();

        // Create headers array from tableHeaderData
        const headers = tableHeaderData?.map(col => col.Header) || [];

        // Create data array with only the fields specified in tableHeaderData
        const worksheetData = excelData?.map(row => {
            const filteredRow = {};
            tableHeaderData?.forEach(col => {
                filteredRow[col.Header] = row[col.accessor];
            });
            return filteredRow;
        }) || [];

        // Convert data to worksheet format with proper headers
        const ws = XLSX.utils.json_to_sheet(worksheetData, { header: headers });

        // Add worksheet to workbook
        XLSX.utils.book_append_sheet(wb, ws, 'report');

        // Write the file
        XLSX.writeFile(wb, 'Wholesale Customer.xlsx');
    };

    return (
        <Row style={{ position: 'relative' }}>
            <div className="ExcelTable" id='dvTable'>
                <Button
                    disabled={!data.length}
                    className="download-monthly-sub-order-report btn-primary btn btn-sm"
                    onClick={handleDownload}
                >
                    Download
                </Button>
            </div>


            {data.length ? (
                <ResizableDataTable customClass="pt-0" reactTableData={{ tableHeaderData }} data={data} />
            ) : <div className="no-data">No data to display</div>}
        </Row>
    )
}

customerTable.propTypes = {
    data: PropTypes.array.isRequired,
    tableHeaderData: PropTypes.array.isRequired,
};


export default customerTable;